import React, { useEffect } from "react";
import ChatSection from "../chat/ChatSection";
import useChatNotifications from "../../hooks/useChatNotifications";

const HospitalChat = () => {
  const { markAsSeen } = useChatNotifications("hospital");

  useEffect(() => {
    markAsSeen();
    const timer = setInterval(() => markAsSeen(), 5000);
    return () => clearInterval(timer);
  }, [markAsSeen]);

  return <ChatSection mode="hospital" />;
};

export default HospitalChat;
